import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=08bbc208&scoped=true&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"
import style0 from "./Login.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Login.vue?vue&type=style&index=1&id=08bbc208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bbc208",
  null
  
)

export default component.exports